import { IOffer, IPhotoLabel } from '../../../types';

export const preparePhotoLabels = (offer: IOffer): IPhotoLabel[] => {
  if (!offer.author?.bank || offer.author?.agentLists) {
    return offer.photoLabels;
  }

  return [];
};
